import { msg } from '@lingui/core/macro';
import { AUTO_KIT_TYPE } from 'shared/kit';
import { commonPlaceholder } from 'modules/overlay-canvas/types/placeholders/create-argument';
import type { MessageDescriptor } from 'shared/i18n/i18n';

interface IItem extends commonPlaceholder {
  /** Подпись кнопки в меню. `blockText` — текст объекта на канве, он сохраняется в табло и не переводится. */
  listName: MessageDescriptor;
}

export const commonPlaceholderList: IItem[] = [
  {
    listName: msg`Город`,
    indicator: 'city',
    blockText: 'Город',
    type: 'text',
  },
  {
    listName: msg`Логотип турнира`,
    indicator: 'organizerLogo',
    blockText: 'Логотип турнира',
    type: 'image',
  },
  {
    listName: msg`Название чемпионата`,
    indicator: 'championshipName',
    blockText: 'Название чемпионата',
    type: 'text',
  },
  {
    listName: msg`Время начала матча`,
    indicator: 'startMatchTime',
    blockText: 'Время начала матча',
    type: 'text',
  },
  {
    listName: msg`Дата начала матча`,
    indicator: 'startMatchDate',
    blockText: 'Дата начала матча',
    type: 'text',
  },
  {
    listName: msg`Время матча`,
    indicator: 'matchTime',
    blockText: 'Время матча',
    type: 'text',
  },
  {
    listName: msg({ message: 'Логотип\nкоманды' }),
    indicator: 'teamLogo',
    blockText: 'Логотип команды',
    type: 'image',
    teamIndex: 0,
  },
  {
    listName: msg({ message: 'Форма\nкоманды' }),
    indicator: 'teamKit',
    blockText: 'Форма команды',
    type: 'image',
    teamIndex: 0,
    kitType: AUTO_KIT_TYPE,
    kitElements: 'full',
  },
  {
    listName: msg`Название команды`,
    indicator: 'teamName',
    blockText: 'Название команды',
    type: 'text',
    teamIndex: 0,
  },
  {
    listName: msg({ message: 'Короткое название\nкоманды' }),
    indicator: 'teamShortName',
    blockText: 'Короткое название команды',
    type: 'text',
    teamIndex: 0,
  },
  {
    listName: msg`Счёт команды`,
    indicator: 'teamScore',
    blockText: 'Счёт команды',
    type: 'text',
    teamIndex: 0,
  },
  {
    listName: msg`Фолы команды`,
    indicator: 'teamFouls',
    blockText: 'Фолы команды',
    type: 'text',
    teamIndex: 0,
  },
  // Индикаторы намеренно не совпадают с событийными `teamShootoutGoals`/`teamShootoutMisses`:
  // те ищутся по `teamReverse` и живут только в карточке события, эти — по `teamIndex`
  // и держатся на табло всю серию.
  {
    listName: msg`Счёт серии пенальти`,
    indicator: 'teamShootoutScore',
    blockText: 'Счёт серии пенальти',
    type: 'text',
    teamIndex: 0,
  },
  {
    listName: msg({ message: 'Промахи в серии\nпенальти' }),
    indicator: 'teamShootoutMissCount',
    blockText: 'Промахи в серии пенальти',
    type: 'text',
    teamIndex: 0,
  },
  {
    listName: msg`Тайм`,
    indicator: 'period',
    blockText: 'Тайм',
    type: 'text',
  },
];
